// import { message } from 'ant-design-vue'
import conf from './conf'

export default {
  骆健星: {
    joinToken (target) {
      target.token = window.localStorage.getItem('token') || ''
    },
    renderList (res) {
      return res.data.data.list || []
    },
    joinPage (target, paging) {
      target.pageNum = paging.pageNo - 1
      target.pageSize = paging.pageSize
    },
    renderTotal (res) {
      const count = res.data.data.page ? res.data.data.page.totalCount : res.data.data.totalCount ? res.data.data.totalCount : res.data.data.total
      return count
    },
    renderError (res, i18n) {
      if (res.status === 404) {
        return i18n.messages[i18n.locale].message.requestNotFound
      }

      if (res.status === 500) {
        return i18n.messages[i18n.locale].message.requestException
      }

      switch (Number(res.data.code)) {
        case 200:
          return null
        default:
          return res.data.msg || res.data.message || i18n.messages[i18n.locale].message.requestException
      }
    },
    judgeResponse (res, noLoginFn, router) {
      return new Promise((resolve, reject) => {
        if (res.status === 404) {
          reject()
        } else {
          switch (Number(res.data.code)) {
            case 200:
              resolve()
              break
            case 1000:
              if (typeof noLoginFn === 'function') {
                noLoginFn()
              } else {
                window.localStorage.setItem('callback', window.location.href)
                router.push({ name: conf.loginRouter })
              }
              window.localStorage.removeItem('token')
              break

            default:
              reject()
              break
          }
        }
      })
    }
  },
  梁炜平: {
    joinToken (target) {
      target.token = window.localStorage.getItem('token') || ''
    },
    renderList (res) {
      return res.data.data.list || res.data.data || []
    },
    joinPage (target, paging) {
      target.pageNo = paging.pageNo
      target.pageSize = paging.pageSize
    },
    renderTotal (res) {
      return res.data.data.total
    },
    renderError (res, i18n) {
      switch (res.status) {
        case 200:
          return null

        case 404:
          return i18n.messages[i18n.locale].message.requestNotFound

        case 500:
          return i18n.messages[i18n.locale].message.requestException

        default:
          if (res.data) {
            return res.data.message || i18n.messages[i18n.locale].message.requestException
          }
          return i18n.messages[i18n.locale].message.requestException
      }
    },
    judgeResponse (res, noLoginFn, router) {
      return new Promise((resolve, reject) => {
        switch (res.status) {
          case 200:
            resolve()
            break

          case 404:
            reject()
            break

          case 401:
            if (typeof noLoginFn === 'function') {
              noLoginFn()
            } else {
              window.localStorage.setItem('callback', window.location.href)
              router.push({ name: conf.loginRouter })
            }
            window.localStorage.removeItem('token')
            break

          default:
            reject()
            break
        }
      })
    }
  },
  黎柱权: {
    joinToken (target) {
      target.Authorization = `Bearer ${window.localStorage.getItem('token') || ''}`
    },
    renderList (res) {
      return res.data.data.records || res.data.data || []
    },
    joinPage (target, paging) {
      target.current = paging.pageNo
      target.size = paging.pageSize
    },
    renderTotal (res) {
      return res.data.data.total
    },
    renderError (res, i18n) {
      if (res.status === 404) {
        return i18n.messages[i18n.locale].message.requestNotFound
      }

      if (res.status === 500) {
        return i18n.messages[i18n.locale].message.requestException
      }

      switch (res.data.code) {
        case '0000000':
          return null

        default:
          return res.data.msg || i18n.messages[i18n.locale].message.requestException
      }
    },
    judgeResponse (res, noLoginFn, router) {
      return new Promise((resolve, reject) => {
        if (res.status === 200) {
          switch (res.data.code) {
            case '0000000':
              resolve()
              break

            case '0010001':
              if (typeof noLoginFn === 'function') {
                noLoginFn()
              } else {
                window.localStorage.setItem('callback', window.location.href)
                router.push({ name: conf.loginRouter })
              }
              window.localStorage.removeItem('token')
              break

            default:
              reject()
              break
          }
        } else if (res.status === 403) {
          if (typeof noLoginFn === 'function') {
            noLoginFn()
          } else {
            window.localStorage.setItem('callback', window.location.href)
            router.push({ name: conf.loginRouter })
          }
          window.localStorage.removeItem('token')
        } else {
          reject()
        }
      })
    }
  },
  郭仕华: {
    joinToken (target) {
      target.Authorization = `Bearer ${window.localStorage.getItem('token') || ''}`
    },
    renderList (res) {
      return res.data.data.records || res.data.data || []
    },
    joinPage (target, paging) {
      target.current = paging.pageNo
      target.size = paging.pageSize
    },
    renderTotal (res) {
      return res.data.data.total
    },
    renderError (res, i18n) {
      switch (res.status) {
        case 200:
          return null

        case 404:
          return i18n.messages[i18n.locale].message.requestNotFound

        case 500:
          return i18n.messages[i18n.locale].message.requestException

        default:
          if (res.data) {
            return res.data.message || i18n.messages[i18n.locale].message.requestException
          }
          return i18n.messages[i18n.locale].message.requestException
      }
    },
    judgeResponse (res, noLoginFn, router) {
      return new Promise((resolve, reject) => {
        switch (res.status) {
          case 200:
            resolve()
            break

          case 404:
            reject()
            break

          case 401:
            if (typeof noLoginFn === 'function') {
              noLoginFn()
            } else {
              window.localStorage.setItem('callback', window.location.href)
              router.push({ name: conf.loginRouter })
            }
            window.localStorage.removeItem('token')
            break

          default:
            reject()
            break
        }
      })
    }
  },
  刘广升: {
    joinToken (target) {
      target.token = window.localStorage.getItem('token') || ''
    },
    renderList (res) {
      return res.data.extra.records || res.data.extra || []
    },
    joinPage (target, paging) {
      target.current = paging.pageNo
      target.size = paging.pageSize
    },
    renderTotal (res) {
      return res.data.extra.total
    },
    renderError (res, i18n) {
      if (res.status === 200) {
        if (res.data.code === 0) {
          if (res.data.extra && res.data.extra.isSuccess !== undefined && res.data.extra.isSuccess === false) {
            return res.data.extra.msg || i18n.messages[i18n.locale].message.requestException
          }
          if (res.data.extra && res.data.extra.code !== undefined && res.data.extra.code !== 0) {
            return res.data.extra.errMsg || i18n.messages[i18n.locale].message.requestException
          }
          if (res.data.extra && res.data.extra.status !== undefined && res.data.extra.status !== '100') {
            return res.data.extra.message || i18n.messages[i18n.locale].message.requestException
          }
          return null
        }
        return res.data.errMsg || i18n.messages[i18n.locale].message.requestException
      }
      switch (res.status) {
        case 404:
          return i18n.messages[i18n.locale].message.requestNotFound

        case 500:
          if (res.data && res.data.code !== undefined && res.data.code === 100105) {
            return null
          }
          return (res.data && res.data.errMsg) || i18n.messages[i18n.locale].message.requestException

        default:
          return i18n.messages[i18n.locale].message.requestException
      }
    },
    judgeResponse (res, noLoginFn, router) {
      return new Promise((resolve, reject) => {
        if (res.status === 200) {
          if (res.data.code === 0) {
            if (res.data.extra && res.data.extra.isSuccess !== undefined && res.data.extra.isSuccess === false) {
              reject()
            } else if (res.data.extra && res.data.extra.code !== undefined && res.data.extra.code !== 0) {
              reject()
            } else if (res.data.extra && res.data.extra.status !== undefined && res.data.extra.status !== '100') {
              reject()
            } else {
              resolve()
            }
          } else if (res.data.code === 100105) {
            if (typeof noLoginFn === 'function') {
              noLoginFn()
            } else {
              window.localStorage.setItem('callback', window.location.href)
              router.push({ name: conf.loginRouter })
            }
            window.localStorage.removeItem('token')
          } else {
            reject()
          }
        } else if (res.status === 500) {
          if (res.data && res.data.code !== undefined && res.data.code === 100105) {
            if (typeof noLoginFn === 'function') {
              noLoginFn()
            } else {
              window.localStorage.setItem('callback', window.location.href)
              router.push({ name: conf.loginRouter })
            }
            window.localStorage.removeItem('token')
          } else {
            reject()
          }
        } else {
          reject()
        }
      })
    }
  },
  全业务: {
    joinToken (target) {
      target['aggcode-token'] = window.localStorage.getItem('token') || ''
    },
    renderList (res) {
      return res.data.extra.data || res.data.extra.list || res.data.extra || []
    },
    joinPage (target, paging) {
      target.page = paging.pageNo - 1
      target.size = paging.pageSize
    },
    renderTotal (res) {
      return res.data.extra.total
    },
    renderError (res, i18n) {
      if (res.status === 200) {
        if (res.data.code === 0) {
          if (res.data.extra && res.data.extra.isSuccess !== undefined && res.data.extra.isSuccess === false) {
            return res.data.extra.msg || i18n.messages[i18n.locale].message.requestException
          }
          if (res.data.extra && res.data.extra.code !== undefined && res.data.extra.code !== 0) {
            return res.data.extra.errMsg || i18n.messages[i18n.locale].message.requestException
          }
          if (res.data.extra && res.data.extra.status !== undefined && res.data.extra.status !== '100') {
            return res.data.extra.message || i18n.messages[i18n.locale].message.requestException
          }
          return null
        }
        return res.data.errMsg || i18n.messages[i18n.locale].message.requestException
      }
      switch (res.status) {
        case 404:
          return i18n.messages[i18n.locale].message.requestNotFound

        case 500:
          if (res.data && res.data.code !== undefined && res.data.code === 100105) {
            return null
          }
          return (res.data && res.data.errMsg) || i18n.messages[i18n.locale].message.requestException

        default:
          return i18n.messages[i18n.locale].message.requestException
      }
    },
    judgeResponse (res, noLoginFn, router) {
      return new Promise((resolve, reject) => {
        if (res.status === 200) {
          if (res.data.code === 0) {
            if (res.data.extra && res.data.extra.isSuccess !== undefined && res.data.extra.isSuccess === false) {
              reject()
            } else if (res.data.extra && res.data.extra.code !== undefined && res.data.extra.code !== 0) {
              reject()
            } else if (res.data.extra && res.data.extra.status !== undefined && res.data.extra.status !== '100') {
              reject()
            } else {
              resolve()
            }
          } else if (res.data.code === 100105) {
            if (typeof noLoginFn === 'function') {
              noLoginFn()
            } else {
              window.localStorage.setItem('callback', window.location.href)
              router.push({ name: conf.loginRouter })
            }
            window.localStorage.removeItem('token')
          } else {
            reject()
          }
        } else if (res.status === 500) {
          if (res.data && res.data.code !== undefined && res.data.code === 100105) {
            if (typeof noLoginFn === 'function') {
              noLoginFn()
            } else {
              window.localStorage.setItem('callback', window.location.href)
              router.push({ name: conf.loginRouter })
            }
            window.localStorage.removeItem('token')
          } else {
            reject()
          }
        } else {
          reject()
        }
      })
    }
  }
}
